import React, { forwardRef, useEffect, useRef, useState } from 'react'
import analytics from 'global/AnalyticsData'
import { getStepLabel } from 'components/NavBar/utils/getStepLabel'
import { t } from 'i18n'
import removeLastStep from 'components/NavBar/utils/remove-last-step'
import './MobileNavBar.style.scss'
import DropDownIconDown from 'images/inline/dropdown-icon.svg'
import DropDownIconUp from 'images/inline/dropdown-icon-active.svg'
import BlurBackground from './BlurBackground'

export const MobileNavBar = forwardRef(function MobileNavBar(
  { stepStatusArr, activeStepPosition, brk, onItemClicked, className, style },
  ref,
) {
  const [open, setOpen] = useState(false)
  const dropdownRef = useRef(null)
  // Current label of mobilenav is kept in state, to make sure it isn't updated to null or ""
  //
  // This is what shows before any step resolves, and on the landing position, where
  // stepStatusArr has no entry. It was the literal 'Start', which stayed English while
  // every other entry in the dropdown translated.
  const [label, setLabel] = useState(() => t('common:start'))

  //Close dropdown when clicking outside of it
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  //Update label when activeStepPosition changes, when we can't get label, do not change it.
  //I'm not sure yet why the active position is f'ed
  useEffect(() => {
    let pos = parseInt(activeStepPosition)
    if (stepStatusArr[activeStepPosition]) {
      let newLabel = getStepLabel({
        label: stepStatusArr[pos].label,
        stepType: stepStatusArr[pos].type,
      })
      if (
        newLabel !== '' &&
        newLabel !== null &&
        newLabel !== undefined &&
        newLabel !== label
      ) {
        setLabel(newLabel)
      }
    }
  }, [activeStepPosition, stepStatusArr])

  return (
    <>
      <div ref={dropdownRef} style={style} className={className}>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          className="menu-container"
        >
          <div
            className="menu-trigger navbar-button"
            onClick={() => {
              setOpen(!open)
            }}
          >
            <button
              className="mobile-navbar-button"
              dangerouslySetInnerHTML={{
                __html: label,
              }}
            ></button>
            {!open ? <DropDownIconDown /> : <DropDownIconUp />}
          </div>

          <div className={`dropdown-menu ${open ? 'active' : 'inactive'}`}>
            {removeLastStep(stepStatusArr)?.map((stepStatus, index) => {
              const stepActive =
                stepStatus.position === parseInt(activeStepPosition)
              const isFirstStep = parseInt(activeStepPosition) === 0

              if (isFirstStep && index === 0) {
                return null
              }
              return (
                <li
                  onClick={() => {
                    analytics.breakEvent('menu_navigation_click', brk, {
                      context: activeStepPosition,
                      result: index,
                      context_total: stepStatusArr.length,
                      context_position: activeStepPosition,
                    })
                    onItemClicked &&
                      onItemClicked({
                        stepId: stepStatus.id,
                        position: index,
                        isLocked: stepStatus.locked,
                        isAlreadyTaken: stepStatus.complete,
                      })
                    setOpen(false)
                  }}
                  key={index}
                  className={`navbar-dropdown-button ${
                    stepActive ? 'active' : ''
                  }`}
                  dangerouslySetInnerHTML={{
                    __html: getStepLabel({
                      label: stepStatus.label,
                      stepType: stepStatus.type,
                    }),
                  }}
                ></li>
              )
            })}
          </div>
        </div>
      </div>
      <BlurBackground open={open} />
    </>
  )
})
